module.exports = __webpack_public_path__ + "static/media/icon-circle-light-play-small@3x.c5e2d39c.png";